import { Divider } from '@mui/material'
import { Close, ContentCopyRounded } from '@mui/icons-material'
import Modal from 'react-modal'

export default function UserBankAccounts({ bankAccountsVisible, setBankAccountsVisible, bankAccounts }) {
  const customStyles = {
    content: {
      borderRadius: '1.5rem',
      height: 'fit-content',
      maxHeight: 600,
      maxWidth: 600,
      margin: 'auto',
      padding: '2rem'
    },
    overlay: {
      zIndex: 90,
      backgroundColor: 'rgba(0,0,0,0.5)'
    }
  }

  const handleCopy = text => {
    navigator.clipboard.writeText(text)
  }

  const getAccountType = type => {
    if (type === 'checking') return 'Cuenta corriente'
    else if (type === 'savings') return 'Caja de ahorro'
    else if (type === 'cashier') return 'Cuenta cajero'
  }

  return (
    <>
      <Modal
        isOpen={bankAccountsVisible}
        onRequestClose={() => setBankAccountsVisible(false)}
        style={customStyles}
      >
        <div className='flex flex-col h-full'>
          <div className='flex flex-row justify-end'>
            <Close onClick={() => setBankAccountsVisible(false)} className='text-primary' />
          </div>
          {bankAccounts.map((account, index) => (
            <div className='flex flex-col gap-4' key={account.id}>
              <div className='flex flex-row gap-2'>
                <p>
                  <span className='font-bold'>Nombre titular:</span>{' '}
                  {account.owner_full_name ??
                    account.owner_first_name + ' ' + account.owner_last_name}
                </p>
                <ContentCopyRounded
                  className='cursor-pointer hover:opacity-50 text-[#d65944]'
                  onClick={() =>
                    handleCopy(
                      account.owner_full_name ??
                        account.owner_first_name + ' ' + account.owner_last_name
                    )
                  }
                />
              </div>
              <div className='flex flex-row gap-2'>
                <p>
                  <span className='font-bold'>
                    {account.currency === 'ARS' ? 'CUIL' : 'CI'} titular:
                  </span>{' '}
                  {account.owner_id_number}
                </p>
                <ContentCopyRounded
                  className='cursor-pointer hover:opacity-50 text-[#d65944]'
                  onClick={() => handleCopy(account.owner_id_number)}
                />
              </div>
              {account.bank_name && (
                <p>
                  <span className='font-bold'>Banco:</span> {account.bank_name}
                </p>
              )}
              <div className='flex flex-row gap-2'>
                <p>
                  <span className='font-bold'>
                    {account.currency === 'ARS' ? 'CVU/CBU/Alias:' : 'Número de cuenta:'}{' '}
                  </span>
                  {account.account_number}
                </p>
                <ContentCopyRounded
                  className='cursor-pointer hover:opacity-50 text-[#d65944]'
                  onClick={() => handleCopy(account.account_number)}
                />
              </div>
              <p>
                <span className='font-bold'>Tipo de cuenta:</span>{' '}
                {getAccountType(account.account_type)}
              </p>
              {index < bankAccounts.length - 1 && (
                <Divider sx={{ width: '100%', marginBottom: 4, marginTop: 2 }} />
              )}
            </div>
          ))}
        </div>
      </Modal>
    </>
  )
}
